// @flow
/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    error: {
        id: 'devices.error',
        defaultMessage: 'There was an error retrieving your devices'
    },
    nameChanged: {
        id: 'device.name-changed',
        defaultMessage: 'Device name changed successfully'
    },
    nameChangeError: {
        id: 'device.name-change-error',
        defaultMessage: 'Device name could not be changed'
    },
    deviceRemoved: {
        id: 'device.removed',
        defaultMessage: 'Device successfully removed'
    },
    deviceRemoveError: {
        id: 'device.remove-error',
        defaultMessage: 'Device could not be removed. Please try again'
    },
    groupRemoved: {
        id: 'devices.group.removed',
        defaultMessage: 'Group successfully removed'
    },
    groupRemoveError: {
        id: 'devices.group.remove-error',
        defaultMessage: 'Group could not be removed. Please try again'
    },
    hubOfflineError: {
        id: 'devices.hub-offline-error',
        defaultMessage:
            'Sorry, your hub is not talking to us, it\'s appearing offline - check its connection. <a target="_blank" href="https://www.hivehome.com/in-app/hubs-not-talking">Need help?</a>'
    },
    thermostatOfflineError: {
        id: 'devices.thermostatOfflineError',
        defaultMessage:
            'Sorry, your thermostat is not talking to us - check its connection. <a target="_blank" href="https://www.hivehome.com/thermostats-not-talking">Need help?</a>'
    },
    needHelp: {
        id: 'devices.needHelp',
        defaultMessage: 'Need help?'
    }
});



// WEBPACK FOOTER //
// ./src/core/state/devices/intl.js